import React from "react";
import { Filter, TextInput } from "react-admin";

export const DyanamicLayoutFilter = (props) => (
  <Filter {...props}>
    <TextInput label="Search by site name" source="site" alwaysOn />
  </Filter>
);
